import { render, staticRenderFns } from "./TreatmentSection.vue?vue&type=template&id=c163c10c&scoped=true"
import script from "./TreatmentSection.vue?vue&type=script&lang=js"
export * from "./TreatmentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c163c10c",
  null
  
)

export default component.exports